/* ============
 * Mutations for the search module
 * ============
 *
 * The mutations that are available on the
 * search module.
 */

import { INITIAL, INITIALDETAILS, SELECTEDSEARCH } from './mutation-types';

export default {
  [INITIAL](state, payload) {
    state.searchInitial = payload;
  },
  [INITIALDETAILS](state, payload) {
    state.searchInitialDetails = payload;
  },
  [SELECTEDSEARCH](state, payload) {
    state.selectedSearch = payload.selected;
    state.projectListQueryParams = payload.queryParams;
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/search/mutations.js